import { useRef } from "react";
import styles from "./SubscriptionSection.module.css";
import SubscriptionForm from "./SubscriptionForm";
import newsletterExample from "../assets/newsletter_example.png";

type Props = {
  stickyBanner?: boolean;
  /**
   * Optional override text for the banner.
   * Default: "Ne rate plus aucun événement à Québec — abonne-toi."
   */
  bannerText?: string;
};

export default function SubscriptionSection({
  stickyBanner = false,
  bannerText = "Ne rate plus aucun événement à Québec — abonne-toi gratuitement!"
}: Props) {
  const bannerRef = useRef<HTMLDivElement | null>(null);

  if (stickyBanner) {
    return (
      <>
        <div
          ref={bannerRef}
          className={styles.banner}
          role="region"
          aria-label="Infolettre alentours"
        >
          <div className={styles.bannerContent}>
            <span className={styles.bannerText}>{bannerText}</span>
            <div className={styles.bannerActions}>
              <a href="#subscribe-form" className={styles.bannerCta}>
                Je m’abonne
              </a>
            </div>
          </div>
        </div>
      </>
    );
  }

  // Default (non-sticky) section you already have
  return (
    <div className={styles.parent}>
      <div id="subscribe" className={styles.container}>
        <h2>Ta ville a plein d’événements à offrir</h2>
        <div className={styles.flexContainer}>
          <div className={styles.text}>
            <h1>Tu cherches quoi faire à Québec?</h1>

            <p>
              Tanné.e de rester chez toi? <br />
              Dis-nous ce que tu aimes, on t’envoie les meilleurs <br />
              événements sur mesure chaque semaine ! <br />
            </p>
          </div>
          <img src={newsletterExample} className={styles.newsletterExample} alt="newsletter example" />
        </div>
        <div className={styles.flexRight} id="subscribe-form">
          <SubscriptionForm />

          {/* <Bubble threshold={310}>
            <div className={styles.infolettreBox}>
              alentours <br /> a maintenant une <br />
              <strong>infolettre</strong>!
            </div>
          </Bubble> */}
        </div>
      </div>
    </div>
  );
}
